import React, { useMemo } from "react";
import { Table, DropdownProps, Dropdown } from "semantic-ui-react";

export type FacilityProgramDto = {
  facility: string; // e.g., 'ETTF'
  facilityCode: string;
  program: string; // e.g., 'ISF Female Probation SACT'
  programCode: string;
};

export const FACILITY_PROGRAMS: FacilityProgramDto[] = [
  /*
  {
    facility: "Bay Correctional Facility",
    facilityCode: "BCF",
    program: "A2 - Gen Pop",
    programCode: "bay_cf",
  },*/
  {
    facility: "Bay CF",
    facilityCode: "BCF",
    program: "A2 - GEN POP AM",
    programCode: "bay_cf_a2_am, bay_cf_am, bay_cf_a.m",
  },
  {
    facility: "Bay CF",
    facilityCode: "BCF",
    program: "A2 - GEN POP PM",
    programCode: "bay_a2_pm, bay_cf_pm, bay_cf_p.m",
  },
  /*
  {
    facility: "Bay Correctional Facility",
    facilityCode: "BCF",
    program: "Unified Protocol",
    programCode: "bay_unified",
  },*/
  {
    facility: "Bradshaw Jail",
    facilityCode: "BSJ",
    program: "ISF COG M",
    programCode: "bsj_bradshaw, bradshaw",
  },
   {
    facility: "Bradshaw Jail",
    facilityCode: "BSJ",
    program: "ISF COG M",
    programCode: "bsj_bradshaw, bradshaw",
  },
  {
    facility: "East Mississippi CF",
    facilityCode: "EMCF",
    program: "Alcohol and Drug",
    programCode: "east_mississippi, emcf",
  },
  {
    facility: "East Mississippi CF",
    facilityCode: "EMCF",
    program: "Faith Based",
    programCode: "emcf_faith",
  },
  {
    facility: "East Mississippi CF",
    facilityCode: "EMCF",
    program: "Pre-Release",
    programCode: "emcf_emcf_pre_release, emcf_pre_release",
  },
  {
    facility: "East Texas Treatment",
    facilityCode: "ETTF",
    program: "Pro SACT F",
    programCode: "ettf_isf_probation_female, isf_probation_female, isf_probation_female_sact",
  },
  {
    facility: "East Texas Treatment",
    facilityCode: "ETTF",
    program: "Pro SACT M",
    programCode: "ettf_isf_male_probation, isf_male_probation, isf_probation_male, isf_probation_male_sact",
  },
  {
    facility: "East Texas Treatment",
    facilityCode: "ETTF",
    program: "ISF F PAR COG 45 Day",
    programCode: "ettf_isf_female_parole, isf_female_parole, isf_f_parole, isf_female_cog,  isf_f_cog",
  },
  /*
  {
    facility: "East Texas Treatment Facility",
    facilityCode: "ETTF",
    program: "ISF Female Probation Cognitive",
    programCode: "isf_female_probation_",
  }, */
  {
    facility: "East Texas Treatment",
    facilityCode: "ETTF",
    program: "PRO PAR COG M",
    programCode: "ettf_isf_male_probation_parole, isf_male_probation_parole",
  },
  {
    facility: "East Texas Treatment",
    facilityCode: "ETTF",
    program: "DWI PAR",
    programCode: "ettf_dwi_parole, dwi_parole",
  },
  {
    facility: "East Texas Treatment",
    facilityCode: "ETTF",
    program: "DWI COG PRO",
    programCode: "ettf_dwi_probation, dwi_probation",
  },
  {
    facility: "East Texas Treatment",
    facilityCode: "ETTF",
    program: "SAFP F",
    programCode: "ettf_safp_female, safp_female",
  },
  {
    facility: "East Texas Treatment",
    facilityCode: "ETTF",
    program: "SAFP M",
    programCode: "ettf_safp_male, safp_male",
  },
  {
    facility: "East Texas Treatment",
    facilityCode: "ETTF",
    program: "SAFP M rest-ART",
    programCode: "ettf_safp_male_art, safp_male_art",
  },
  /*
  {
    facility: "Gadsden Correctional Facility",
    facilityCode: "GCF",
    program: "Shaping Success for Women",
    programCode: "gadsden_",
  },
  {
    facility: "Gadsden Correctional Facility",
    facilityCode: "GCF",
    program: "Shaping Success for Women AM",
    programCode: "gadsden_am_",
  },
  {
    facility: "Gadsden Correctional Facility",
    facilityCode: "GCF",
    program: "Shaping Success for Women PM",
    programCode: "gadsden_pm_",
  },*/

  {
    facility: "Graceville CF",
    facilityCode: "GVCF",
    program: "C2 GEN POP",
    programCode: "graceville, gvcf",
  },
  /*
  {
    facility: "Graceville Correctional Facility",
    facilityCode: "GVCF",
    program: "Mental Health Group",
    programCode: "gvcf_",
  },
  {
    facility: "Graceville Correctional Facility",
    facilityCode: "GVCF",
    program: "Unified Protocol",
    programCode: "gvcf_",
  },
  {
    facility: "Panama City Community Release Center ",
    facilityCode: "PCCRC",
    program: "Work Release Program",
    programCode: "panama_",
  },*/
    {
    facility: "North Central Correction (NCCC)",
    facilityCode: "NCCC",
    program: "Shaping Success",
    programCode: "nccc_shape_success",
  },
    {
    facility: "North Central Correction (NCCC)",
    facilityCode: "NCCC",
    program: "Recovery Services AM",
    programCode: "nccc_rec_serv_am",
  },
    {
    facility: "North Central Correction (NCCC)",
    facilityCode: "NCCC",
    program: "Recovery Services PM",
    programCode: "nccc_rec_serv_pm",
  },
  {
    facility: "Wilkinson CF",
    facilityCode: "WCF",
    program: "Substance Use",
    programCode: "wccf_a, wccf_alpha",
  },
  {
    facility: "Wilkinson CF",
    facilityCode: "WCF",
    program: "Gen Pop",
    programCode: "wcf_wccf_lima, wccf_lima, wccf_gen",
  },
];

type ScheduleFormProps = {
  selectedFacility?: string;
  selectedProgram?: string;
  selectedProgramCode?: string;
  selectedScheduleName?: string;
  /** NEW: selected schedule year-month (YYYY/MM) */
  selectedScheduleYearMonth?: string;

  weekBeginDate: string;
  submitting: boolean;

  handleSubmit: () => void;
  handleDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleFacilityChange: (facilityName: string, facilityCode: string) => void;
  handleProgramChange: (programName: string, programCode: string) => void;
  handleScheduleNameChange: (scheduleName: string) => void;
  /** NEW: change handler for year-month filter */
  handleScheduleYearMonthChange: (yearMonth: string) => void;
};

function ScheduleForm({
  selectedFacility,
  selectedProgram,
  selectedProgramCode,
  selectedScheduleName,
  selectedScheduleYearMonth, // NEW
  weekBeginDate,
  submitting,
  handleSubmit,
  handleDateChange,
  handleFacilityChange,
  handleProgramChange,
  handleScheduleNameChange,
  handleScheduleYearMonthChange, // NEW
}: ScheduleFormProps) {
  /** util: pad 2 digits */
  //const pad2 = (n: number) => String(n).padStart(2, "0");

  /** Build distinct facility options once */
  function useFacilityOptions(data: FacilityProgramDto[]) {
    return useMemo(() => {
      const uniq = Array.from(new Set(data.map((d) => d.facility)));
      return uniq.map((f) => ({ key: f, text: f, value: f }));
    }, [data]);
  }

  function useProgramOptions(data: FacilityProgramDto[], facility?: string) {
    return useMemo(() => {
      if (!facility) return [];

      const rows = data.filter((d) => d.facility === facility);

      // Do NOT dedupe by program name—different codes matter
      return rows.map((d) => {
        const code = (d.programCode || "")
          .split(",")[0] // take first if comma-separated
          .trim();

        return {
          key: `${d.facility}-${d.program}-${code || "nocode"}`,
          text: d.program,
          value: code,
          description: code || "—",
          disabled: !code,
        };
      });
    }, [data, facility]);
  }

  /** NEW: last 3 months list (current + previous 2), formatted as YYYY/MM */
  // Put this at module scope (outside any component)
  function useYearMonthOptions(previousMonths: number = 3, futureMonths: number = 0) {
  const now = new Date();
  const y = now.getUTCFullYear();
  const m0 = now.getUTCMonth(); // 0-based

  return React.useMemo(() => {
    const clamp0 = (n: number) => Math.max(0, n);
    const prev = clamp0(previousMonths);
    const fut = clamp0(futureMonths);

    const pad2 = (x: number) => String(x).padStart(2, "0");
    const makeYm = (d: Date) => `${d.getUTCFullYear()}/${pad2(d.getUTCMonth() + 1)}`;

    // Start at the beginning month in the range and end at the last
    const start = new Date(Date.UTC(y, m0 - prev, 1));
    const end   = new Date(Date.UTC(y, m0 + fut, 1));

    const items: { key: string; text: string; value: string }[] = [];

    items.push({key: "", text: "", value: ""})
    // Iterate from end → start (newest first)
    for (
      let d = new Date(end);
      d.getUTCFullYear() > start.getUTCFullYear() ||
      (d.getUTCFullYear() === start.getUTCFullYear() && d.getUTCMonth() >= start.getUTCMonth());
      d.setUTCMonth(d.getUTCMonth() - 1)
    ) {
      const ym = makeYm(d);
      items.push({ key: ym, text: ym, value: ym });
    }

    return items;
  }, [previousMonths, futureMonths, y, m0]);
}


  const facilityOptions = useFacilityOptions(FACILITY_PROGRAMS);
  const programOptions = useProgramOptions(FACILITY_PROGRAMS, selectedFacility);
  const yearMonthOptions = useYearMonthOptions(3, 3); // NEW

  const onFacilityChange = (
    _: React.SyntheticEvent<HTMLElement>,
    data: DropdownProps
  ) => {
    const facilityName = (data.value as string) ?? "";
    const row = FACILITY_PROGRAMS.find((d) => d.facility === facilityName);
    handleFacilityChange(facilityName, row?.facilityCode ?? "");
    handleProgramChange("", "");
  };

  const onProgramChange = (
    _: React.SyntheticEvent<HTMLElement>,
    data: DropdownProps
  ) => {
    const programCode = (data.value as string) ?? "";
    const row = FACILITY_PROGRAMS.find(
      (d) =>
        d.facility === selectedFacility &&
        d.programCode
          .split(",")
          .map((s) => s.trim())
          .includes(programCode)
    );
    handleProgramChange(row?.program ?? "", programCode);
  };

  return (
    <Table stackable columns={1} style={{maxWidth: 500}}>
      <Table.Body>
        <Table.Row>
          <Table.Cell colSpan={1}>
            <b>Filters:</b>
          </Table.Cell>
        </Table.Row>

        <Table.Row>
          <Table.Cell>
            {/* Facility Dropdown */}
            <Dropdown
              placeholder="Select Facility"
              fluid
              selection
              size="large"
              options={facilityOptions}
              value={selectedFacility || ""}
              onChange={onFacilityChange}
            />
          </Table.Cell>
        </Table.Row>
        <Table.Row>
            <Table.Cell>
            {/* Program Dropdown (filtered by facility) */}
            <Dropdown
              placeholder={
                selectedFacility ? "Select Program" : "Select Facility First"
              }
              fluid
              selection
              size="large"
              disabled={!selectedFacility}
              options={programOptions}
              value={selectedProgramCode || ""}
              onChange={onProgramChange}
            />
          </Table.Cell>
        </Table.Row>

        {/* NEW: Year/Month filter row */}
        <Table.Row>
          <Table.Cell>
            <Dropdown
              placeholder="Select Targeted Year/Month"
              fluid
              selection
              size="large"
              options={yearMonthOptions}
              value={
                selectedScheduleYearMonth || yearMonthOptions[0]?.value || ""
              }
              onChange={(_, data) =>
                handleScheduleYearMonthChange((data.value as string) ?? "")
              }
            />
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}

export default ScheduleForm;
